/**
 * Corporate affiliations reported by the CRM on a funeral home location.
 * These drive corporate-specific business rules, such as which documents and
 * OAP payment plans a funeral home is allowed to use.
 */
export enum CorporateAffiliation {
	Carriage = 'Carriage',
}
